module.exports = __webpack_public_path__ + "img/abs.cbb42631.png";